module.exports = __webpack_public_path__ + "media/images/admin/icons/chevron-right-d45fd2f46e93f5c3aa0a7d0617d9fecf.svg";